module.exports = __webpack_public_path__ + "static/assets/809d6cb7f9b548ad3f360a4d72a93167.png";